export default function Problem() {
  const problems = [
    {
      icon: 'ri-eye-off-line',
      title: 'Difficulté de contrôler l\'état du bien',
      description: 'Impossible de vérifier régulièrement l\'état réel de votre propriété depuis l\'étranger.'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Villas qui se dégradent sans visibilité',
      description: 'Les problèmes s\'accumulent sans que vous en soyez informé, causant des dégâts coûteux.'
    },
    {
      icon: 'ri-user-unfollow-line',
      title: 'Prestataires peu fiables',
      description: 'Manque de professionnalisme et absence de suivi structuré de la part des intervenants locaux.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Absence de suivi structuré',
      description: 'Aucun reporting clair ni documentation des interventions et de l\'état de votre bien.'
    }
  ];

  return (
    <section id="probleme" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="inline-block bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Le Défi des Propriétaires
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3B5C] leading-tight max-w-3xl">
            Les défis de la gestion immobilière à distance
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] p-10 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${problem.icon} text-[#1A3B5C] text-5xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#F8F9FA] to-white p-8 rounded-2xl border-l-4 border-[#C9A961] relative">
          <div className="absolute -top-4 -left-4 text-[#C9A961] opacity-15 text-8xl font-serif">"</div>
          <p className="text-xl md:text-2xl text-gray-700 italic font-serif relative z-10">
            Comment puis-je être certain que ma villa est bien entretenue quand je suis à Paris ?
          </p>
          <p className="text-gray-500 mt-4 font-medium">— Question récurrente des propriétaires</p>
        </div>
      </div>
    </section>
  );
}
